import {
  useEffect,
  useRef,
  useState,
  useMemo,
  forwardRef,
  useImperativeHandle,
} from "react";
import { CHAT_DATA } from "./chatData";
import { useGame } from "../header/GameContext";

import "./chat.css";

const ChatBoxType2 = forwardRef(function ChatBoxType2(
  {
    DateVal,
    titImgClass = "",
    timerMode,
    chatClass = "chat_box4",
    onFinish,
    onButton,
  },
  ref,
) {
  const {
    correctCount,
    TOTAL_GAME_TIME,
    time,
    startTimer,
    pauseTimer,
    suspectScore,
  } = useGame();

  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleContents, setVisibleContents] = useState([]);
  const chatBoxRef = useRef(null);

  /* =========================
     타이머
  ========================= */
  useEffect(() => {
    timerMode === "run" ? startTimer() : pauseTimer();
  }, [timerMode]);

  /* =========================
     점수 안정화
  ========================= */
  const safeCorrectCount = Math.min(correctCount || 0, 6);
  const finalQuizScore = safeCorrectCount * 10;
  const totalQuizScore = finalQuizScore + (suspectScore || 0);

  /* =========================
     클리어 시간 계산
     ADMIN_TIME_KEY = 관리자 설정 원래값 (syncTimer로 변경되지 않음)
     GAME_TIME_REMAIN = 현재 남은시간 (타이머가 멈춰도 마지막 저장값 유지)
  ========================= */
  const safeTotal =
    Number(localStorage.getItem("ADMIN_TIME_KEY")) ||
    Number(TOTAL_GAME_TIME) ||
    0;
  const safeTime =
    Number(localStorage.getItem("GAME_TIME_REMAIN")) || Number(time) || 0;

  const invalidTime =
    !isFinite(safeTotal) ||
    !isFinite(safeTime) ||
    safeTotal <= 0 ||
    safeTime < 0;

  let escapeTime = "-";

  if (!invalidTime) {
    const usedTime = safeTotal - safeTime;
    if (usedTime > 0) {
      const minutes = Math.floor(usedTime / 60);
      const seconds = usedTime % 60;
      escapeTime = `${minutes}분 ${seconds < 10 ? "0" : ""}${seconds}초`;
    }
  }

  /* =========================
     데이터 치환
  ========================= */
  const rawContents = Array.isArray(DateVal) ? DateVal : CHAT_DATA[DateVal];

  const contents = useMemo(
    () =>
      rawContents.map((item) => ({
        ...item,
        text: item.text
          ?.replace("{{finalQuizScore}}", String(finalQuizScore))
          ?.replace("{{suspectScore}}", String(suspectScore || 0))
          ?.replace("{{totalQuizScore}}", String(totalQuizScore))
          ?.replace("{{clearTime}}", String(escapeTime)),
      })),
    [rawContents, finalQuizScore, suspectScore, totalQuizScore, escapeTime],
  );

  /* 외부 resume */
  useImperativeHandle(ref, () => ({
    resume() {
      setCurrentIndex((prev) => prev + 1);
    },
  }));

  /* =========================
     채팅 자동 진행
  ========================= */
  useEffect(() => {
    if (currentIndex >= contents.length) return;

    const item = contents[currentIndex];

    if (item.type === "button") {
      onButton && onButton(item);
      return;
    }

    const textLength = item.text ? item.text.length : 10;
    const delay = Math.min(120 + textLength * 12, 600);

    const t = setTimeout(() => {
      setVisibleContents((prev) => {
        const next = prev.slice();
        next.push(item);
        return next;
      });
      setCurrentIndex((prev) => prev + 1);
    }, delay);

    return () => clearTimeout(t);
  }, [currentIndex, contents, onButton]);

  /* =========================
     스크롤
  ========================= */
  useEffect(() => {
    if (!chatBoxRef.current) return;
    chatBoxRef.current.scrollTo({
      top: chatBoxRef.current.scrollHeight,
      behavior: "smooth",
    });
  }, [visibleContents]);

  return (
    <div className={`${chatClass} mt24`} id="chat_box" ref={chatBoxRef}>
      {visibleContents.map((c, i) => {
        if (c.type === "chatInfo_Talk1") {
          return (
            <div
              key={i}
              className={`chatInfo_Talk ${c.marType || ""}`}
              dangerouslySetInnerHTML={{ __html: c.text }}
            />
          );
        }

        if (c.type === "leftCharacter") {
          return (
            <div key={i} className={`chat_b_left ${c.marType || ""}`}>
              <div className="chat_b_l_left mr8">
                <span className={c.chat_icon}></span>
              </div>
              <div className="chat_b_l_right">
                <p className="chat_tit mb4">{c.chat_tit}</p>
                <div
                  className={c.talkType}
                  dangerouslySetInnerHTML={{ __html: c.text }}
                />
              </div>
            </div>
          );
        }

        if (c.type === "left_txt") {
          return (
            <div key={i} className={`chat_b_left ${c.marType || ""}`}>
              <div className="chat_b_l_left mr8" />
              <div className="chat_b_l_right">
                <div
                  className={c.talkType}
                  dangerouslySetInnerHTML={{ __html: c.text }}
                />
              </div>
            </div>
          );
        }

        if (c.type === "ImgOnly") {
          return (
            <div key={i} className={c.marType || ""}>
              <img src={c.src} className={c.className} alt="" />
            </div>
          );
        }

        return null;
      })}
    </div>
  );
});

export default ChatBoxType2;
